module.exports = "/_assets/images/theming/hex-characters/corval-hex-video-call.png";